import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { processText } from '@aytm/app/stats/page/components/lib/utils'

// components
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

// styles
import style from '@aytm/app/stats/page/question-views/it/styles/Block.module.scss'

const Block = ({ id, link, header, text, answer, isSurveyGuest, isReportXpert }) => {
  const body_text = 'string' === typeof header && 0 < header.length ? text : ''

  return (
    <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
      {body_text ? (
        <div className={style.instructions} dangerouslySetInnerHTML={{ __html: processText(body_text) }} />
      ) : null}
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  answer: answerPropType,
  link: PropTypes.string,
  header: PropTypes.string,
  text: PropTypes.string,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool
}

export default Block
